// TODO: Move this to nodeHelpers and remove all front-end usage of this
const entities = require("entities");


// Prettify URI's
export function prettyURI(str) {
  str = str.toLowerCase();
  str = str
    .replace(/å/g, "a")
    .replace(/ä/g, "a")
    .replace(/ö/g, "o")

    .replace(/,/g, "")
    .replace(/!/g, "")
    .replace(/\?/g, "")


    .replace(/['()]/g, escape)
    .replace(/[...]/g, "");

  // make the hash the id of the modal shown
  return encodeURIComponent(str)
    .replace(/%20/g, "-"); //space
}

// // Remove the url hash when closing a modal
// export function removeHash() {
//   if (!window) return;
//   console.log('removeHash');
//   if (window.location.hash) {
//     window.history.pushState("", document.title, window.location.pathname + window.location.search);
//   }
// }

export const charFixer = (string) => {
  return entities.decodeXML(string);
};



/**
 * [updateUrl Update the URL with the modal name]
 * @param  {string} newUrl [make the hash the id of the modal shown]
 */
export function updateUrl(newUrl) {
  if (!window) return;
  if (!newUrl) {
    if (window.history.state) {
      window.history.back();
      return;
    }

    // if from external site directly to this url "/talk?the-future-digital-landscape-and-how-it-affects-us-humans" we need to push a state instead of going back
    window.history.pushState("", document.title, window.location.href.split("?talk=")[0]);
    return;
  }

  // window.location.hash = newUrl;
  window.history.pushState(window.location.state, document.title, "?talk=" + newUrl);
  // window.history.pushState(state, null, newUrl); // push state that hash into the url
}
